import React from "react";

const DailyDashboardPreview = (props) => {
  const { brandingColor, theme, isDefaultColor, secondaryTextColor } = props;

  const primaryColor =
    brandingColor && !isDefaultColor ? brandingColor : "#5BC500";
  const bgColor = theme === "light" ? "#F2F2F2" : "#181818";
  const elevationOne =
    theme === "light" ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)";
  const elevationTwo =
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)";
  const textHigh =
    theme === "light" ? "rgba(0, 0, 0, 0.87)" : "rgba(255, 255, 255, 0.87)";
  const textMid =
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)";
  const textLow =
    theme === "light" ? "rgba(0, 0, 0, 0.38)" : "rgba(255, 255, 255, 0.38)";
  const textColor = secondaryTextColor || "#FFFFFF";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="360"
      height="779"
      viewBox="0 0 360 779"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            width="135"
            height="94"
            fill={primaryColor}
            data-name="Rectangle 2494"
            rx="6"
            transform="translate(209 407)"
          ></rect>
        </clipPath>
        <filter
          id="Rectangle_903"
          width="411"
          height="131"
          x="-25.5"
          y="663.5"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="-10"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="8.5"></feGaussianBlur>
          <feFlood floodOpacity="0.659"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <clipPath id="clip-Daily_Dashboard_-_Dark_">
          <path d="M0 0H360V779H0z"></path>
        </clipPath>
      </defs>
      <g
        clipPath="url(#clip-Daily_Dashboard_-_Dark_)"
        data-name="Daily Dashboard - Dark"
      >
        <path fill={bgColor} d="M0 0H360V779H0z"></path>
        <rect
          width="245"
          height="36"
          fill={elevationOne}
          data-name="Rectangle 2561"
          rx="6"
          transform="translate(58 112)"
        ></rect>
        <rect
          width="36"
          height="36"
          fill={elevationOne}
          data-name="Rectangle 2562"
          rx="6"
          transform="translate(307 112)"
        ></rect>
        <rect
          width="36"
          height="36"
          fill={elevationOne}
          data-name="Rectangle 2563"
          rx="6"
          transform="translate(16 112)"
        ></rect>
        <text
          fill={textHigh}
          data-name="Nutrition Targets"
          fontFamily="OpenSans-Medium, Open Sans"
          fontSize="12"
          fontWeight="500"
          transform="translate(16 324)"
        >
          <tspan x="0" y="0">
            Nutrition Targets
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Today's Tasks"
          fontFamily="OpenSans-Medium, Open Sans"
          fontSize="12"
          fontWeight="500"
          transform="translate(16 185)"
        >
          <tspan x="0" y="0">
            Today&apos;s Tasks
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Your Activites"
          fontFamily="OpenSans-Medium, Open Sans"
          fontSize="12"
          fontWeight="500"
          transform="translate(16 606)"
        >
          <tspan x="0" y="0">
            Your Activites
          </tspan>
        </text>
        <rect
          width="328"
          height="127"
          fill={elevationOne}
          data-name="Rectangle 2480"
          rx="6"
          transform="translate(16 340)"
        ></rect>
        <rect
          width="104"
          height="94"
          fill={elevationOne}
          data-name="Rectangle 2490"
          rx="6"
          transform="translate(16 475)"
        ></rect>
        <rect
          width="104"
          height="94"
          fill={elevationOne}
          data-name="Rectangle 2491"
          rx="6"
          transform="translate(128 475)"
        ></rect>
        <rect
          width="104"
          height="94"
          fill={elevationOne}
          data-name="Rectangle 2492"
          rx="6"
          transform="translate(240 475)"
        ></rect>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(45 435)"
        >
          <tspan x="0" y="0">
            Protein
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(56 505)"
        >
          <tspan x="0" y="0">
            Fiber
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(168 505)"
        >
          <tspan x="0" y="0">
            Sleep
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(280 505)"
        >
          <tspan x="0" y="0">
            Steps
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="143"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(52 385)"
        >
          <tspan x="0" y="0">
            143
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="52"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(141 385)"
        >
          <tspan x="-6.85" y="0">
            52
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="122"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(219 385)"
        >
          <tspan x="-10.274" y="0">
            122
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="1576"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(298 385)"
        >
          <tspan x="-13.699" y="0">
            1576
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="of 170"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(48 397)"
        >
          <tspan x="0" y="0">
            of 170
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="of 100"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(141 397)"
        >
          <tspan x="-14.565" y="0">
            of 100
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="of 110"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(219 397)"
        >
          <tspan x="-14.565" y="0">
            of 110
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="of 2000"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(298 397)"
        >
          <tspan x="-17.424" y="0">
            of 2000
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(127 435)"
        >
          <tspan x="0" y="0">
            Carbs
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(219 435)"
        >
          <tspan x="-7.527" y="0">
            Fat
          </tspan>
        </text>
        <text
          fill={textHigh}
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(298 435)"
        >
          <tspan x="-10.322" y="0">
            kCal
          </tspan>
        </text>
        <g
          fill="none"
          stroke={elevationTwo}
          strokeWidth="5"
          data-name="Ellipse 347"
          transform="translate(32 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke="#e90b34"
          strokeDasharray="128"
          strokeLinecap="round"
          strokeWidth="5"
          data-name="Ellipse 348"
          transform="translate(32 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke={elevationTwo}
          strokeWidth="5"
          data-name="Ellipse 349"
          transform="translate(111 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke={elevationTwo}
          strokeWidth="5"
          data-name="Ellipse 351"
          transform="translate(189 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke={elevationTwo}
          strokeWidth="5"
          data-name="Ellipse 353"
          transform="translate(268 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke="#fb9c01"
          strokeDasharray="100"
          strokeLinecap="round"
          strokeWidth="5"
          data-name="Ellipse 350"
          transform="translate(111 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke="#015ef5"
          strokeDasharray="190"
          strokeLinecap="round"
          strokeWidth="5"
          data-name="Ellipse 352"
          transform="translate(189 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="27.5"></circle>
        </g>
        <g
          fill="none"
          stroke="#1ed637"
          strokeDasharray="144"
          strokeLinecap="round"
          strokeWidth="4"
          data-name="Ellipse 354"
          transform="translate(268 356)"
        >
          <circle cx="30" cy="30" r="30" stroke="none"></circle>
          <circle cx="30" cy="30" r="28"></circle>
        </g>
        <g transform="translate(143.935 491)">
          <g data-name="Group 3246">
            <path
              fill="none"
              d="M0 0H20V20H0z"
              data-name="Rectangle 2484"
              transform="translate(.064)"
            ></path>
          </g>
          <g data-name="Group 3248" transform="translate(1.677 1.689)">
            <g data-name="Group 3247">
              <path
                fill={textHigh}
                d="M10.672 2.019a8.381 8.381 0 106.978 12.547 8.376 8.376 0 01-6.978-12.547z"
                data-name="Path 747"
                transform="translate(-2 -2.014)"
              ></path>
            </g>
          </g>
        </g>
        <g data-name="Group 3261" transform="translate(255.871 491)">
          <path
            fill="rgba(255,255,255,0)"
            d="M0 0H20V20H0z"
            data-name="Rectangle 2485"
            transform="translate(.129)"
          ></path>
          <g fill={textHigh} transform="translate(4.193 1.677)">
            <path
              d="M73.318-511.584a2 2 0 00-1.441 1.3 6.7 6.7 0 00-.374 2.1 8.081 8.081 0 00.31 2.6 6.9 6.9 0 001.219 2.876l.118.111.973-.236c.532-.131 1.175-.286 1.425-.344.69-.155.69-.155.852-.707a10.091 10.091 0 00.205-4.142 7.944 7.944 0 00-.616-1.937 2.862 2.862 0 00-1.542-1.569 2.738 2.738 0 00-1.129-.052z"
              data-name="Path 733"
              transform="translate(-71.489 511.622)"
            ></path>
            <path
              d="M287.667-392.459a2.191 2.191 0 00-1.165.65 5.575 5.575 0 00-1.236 2.711 7.156 7.156 0 00-.162 2.028 8.016 8.016 0 00.35 2.438c.135.424.148.434.589.546.172.04.832.2 1.468.357l1.152.28.121-.118a8.278 8.278 0 001.4-3.722 7.484 7.484 0 00.04-2.677c-.182-1.381-.727-2.206-1.607-2.435a3.335 3.335 0 00-.95-.058z"
              data-name="Path 734"
              transform="translate(-277.903 396.484)"
            ></path>
            <path
              d="M130.963-246.816c-.128.047-.771.243-1.428.438s-1.2.354-1.2.36a8.045 8.045 0 00.158 1.068 3.06 3.06 0 001.468 2.213 1.416 1.416 0 001.64-.323c.741-.781.68-2.145-.155-3.546a1.187 1.187 0 00-.212-.293 2.355 2.355 0 00-.271.083z"
              data-name="Path 735"
              transform="translate(-126.416 255.815)"
            ></path>
            <path
              d="M271.782-127.595a5.167 5.167 0 00-.707 1.805 1.86 1.86 0 001.31 2.267c.788.135 1.6-.468 2.041-1.512a6.893 6.893 0 00.4-1.714l.02-.168-1.017-.3a77.716 77.716 0 01-1.465-.441l-.451-.141z"
              data-name="Path 736"
              transform="translate(-264.325 140.727)"
            ></path>
          </g>
        </g>
        <g data-name="Group 3260" transform="translate(32 491)">
          <path
            fill="rgba(255,255,255,0)"
            d="M0 0H20V20H0z"
            data-name="Rectangle 2486"
          ></path>
          <g transform="translate(2.516 1.677)">
            <path
              fill={textHigh}
              d="M42.645-511.622a2.94 2.94 0 00-2.085 1.5 1.209 1.209 0 01-.116.206c-.006 0-.116-.077-.245-.174a5.584 5.584 0 00-1.5-.814.513.513 0 00-.463.827 2.228 2.228 0 00.492.306 3.945 3.945 0 011.882 1.689 2.061 2.061 0 01.238.66 3.069 3.069 0 01-.348-.051 5.156 5.156 0 00-4.663 1.181 4.707 4.707 0 00-1.432 2.6 7.4 7.4 0 00.029 2.252 9.139 9.139 0 002.548 5.074 3.74 3.74 0 002.092 1.139 4.237 4.237 0 001.857-.154l.541-.135.409.1a4.761 4.761 0 001.853.2 3.466 3.466 0 002.227-1.165 8.793 8.793 0 002.359-4.209 7.954 7.954 0 00.206-3.057 4.839 4.839 0 00-2.571-3.449 5.827 5.827 0 00-3.71-.364c-.129.026-.254.048-.277.048s-.064-.1-.1-.251-.093-.341-.135-.454-.077-.206-.077-.212.171-.016.38-.026a2.487 2.487 0 001.075-.264 2.85 2.85 0 001.467-1.689c.138-.418.142-.692.016-.866a2 2 0 00-.8-.393 3.81 3.81 0 00-1.149-.055z"
              data-name="Path 742"
              transform="translate(-34.331 511.643)"
            ></path>
          </g>
        </g>
        <g data-name="Group 3262" transform="translate(-16 187)">
          <text
            fill={textHigh}
            data-name="143"
            fontFamily="OpenSans-Semibold, Open Sans"
            fontSize="12"
            fontWeight="600"
            transform="translate(48 358)"
          >
            <tspan x="0" y="0">
              143
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="/170"
            fontFamily="OpenSans-Regular, Open Sans"
            fontSize="10"
            transform="translate(71 358)"
          >
            <tspan x="0" y="0">
              /170
            </tspan>
          </text>
        </g>
        <text
          fill={textLow}
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(32 558)"
        >
          <tspan x="0" y="0">
            grams
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="(g)"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(55 448)"
        >
          <tspan x="0" y="0">
            (g)
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="(g)"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(134 448)"
        >
          <tspan x="0" y="0">
            (g)
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="(g)"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(214 448)"
        >
          <tspan x="0" y="0">
            (g)
          </tspan>
        </text>
        <text
          fill={textLow}
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(144 558)"
        >
          <tspan x="0" y="0">
            hrs
          </tspan>
        </text>
        <text
          fill={textLow}
          data-name="Steps"
          fontFamily="OpenSans-Regular, Open Sans"
          fontSize="10"
          transform="translate(256 558)"
        >
          <tspan x="0" y="0">
            steps
          </tspan>
        </text>
        <g data-name="Group 3263" transform="translate(99 187)">
          <text
            fill={textHigh}
            data-name="7:05"
            fontFamily="OpenSans-Semibold, Open Sans"
            fontSize="12"
            fontWeight="600"
            transform="translate(45 358)"
          >
            <tspan x="0" y="0">
              7:05
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="/8:00"
            fontFamily="OpenSans-Regular, Open Sans"
            fontSize="10"
            transform="translate(71 358)"
          >
            <tspan x="0" y="0">
              /8:00
            </tspan>
          </text>
        </g>
        <g data-name="Group 3264" transform="translate(218 187)">
          <text
            fill={textHigh}
            data-name="5,421"
            fontFamily="OpenSans-Semibold, Open Sans"
            fontSize="12"
            fontWeight="600"
            transform="translate(38 358)"
          >
            <tspan x="0" y="0">
              5,421
            </tspan>
          </text>
          <text
            fill={textLow}
            data-name="/6,000"
            fontFamily="OpenSans-Regular, Open Sans"
            fontSize="10"
            transform="translate(71 358)"
          >
            <tspan x="0" y="0">
              /6,000
            </tspan>
          </text>
        </g>
        <g data-name="Group 3267" transform="translate(0 -206)">
          <rect
            width="328"
            height="94"
            fill={primaryColor}
            data-name="Rectangle 2493"
            rx="6"
            transform="translate(16 407)"
          ></rect>
          <text
            fill={textColor}
            data-name="Check-In Day"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="20"
            fontWeight="700"
            transform="translate(32 483)"
          >
            <tspan x="0" y="0">
              Check-In Day
            </tspan>
          </text>
          <g clipPath="url(#clip-path)" data-name="Mask Group 1">
            <g data-name="Group 3266" transform="translate(15)">
              <path
                fill="rgba(255,255,255,0.3)"
                d="M20 0h24L24 94H0z"
                data-name="Path 748"
                transform="translate(235 407)"
              ></path>
              <path
                fill="rgba(255,255,255,0.2)"
                d="M20 0h24L24 94H0z"
                data-name="Path 749"
                transform="translate(259 407)"
              ></path>
              <path
                fill={elevationTwo}
                d="M20 0h24L24 94H0z"
                data-name="Path 750"
                transform="translate(283 407)"
              ></path>
              <path
                fill="rgba(255,255,255,0.05)"
                d="M20 0h24L24 94H0z"
                data-name="Path 751"
                transform="translate(307 407)"
              ></path>
            </g>
          </g>
          <path
            fill="none"
            stroke={textColor}
            strokeLinecap="round"
            strokeWidth="2"
            d="M318 448.5l5.894 5.894-5.894 5.894"
            data-name="Path 752"
          ></path>
          <g
            data-name="description_black_24dp (2)"
            transform="translate(32 419)"
          >
            <path fill="none" d="M0 0h20v20H0z" data-name="Path 753"></path>
            <path
              fill={textColor}
              d="M12.405 2H5.681a1.674 1.674 0 00-1.673 1.672L4 17.052a1.674 1.674 0 001.673 1.672h10.094a1.682 1.682 0 001.681-1.672V7.017zm1.681 13.379H7.362v-1.672h6.724zm0-3.345H7.362v-1.672h6.724zm-2.521-4.181v-4.6l4.623 4.6z"
              data-name="Path 754"
              transform="translate(-.724 -.362)"
            ></path>
          </g>
        </g>
        <rect
          width="328"
          height="46"
          fill={elevationOne}
          data-name="Rectangle 2506"
          rx="6"
          transform="translate(16 622)"
        ></rect>
        <rect
          width="328"
          height="46"
          fill={elevationOne}
          data-name="Rectangle 2507"
          rx="6"
          transform="translate(16 676)"
        ></rect>
        <rect
          width="328"
          height="46"
          fill={elevationOne}
          data-name="Rectangle 2508"
          rx="6"
          transform="translate(16 730)"
        ></rect>
        <text
          fill={textHigh}
          data-name="Your workout"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(59 649)"
        >
          <tspan x="0" y="0">
            Your Workout
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Your Meal Plan"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(59 757)"
        >
          <tspan x="0" y="0">
            Your Meal Plan
          </tspan>
        </text>
        <text
          fill={textHigh}
          data-name="Daily Accountability"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="10"
          fontWeight="600"
          transform="translate(59 703)"
        >
          <tspan x="0" y="0">
            Daily Accountability
          </tspan>
        </text>
        <path
          fill="none"
          stroke={textHigh}
          strokeLinecap="round"
          strokeWidth="2"
          d="M321.481 640.5l4.413 4.412-4.413 4.413"
          data-name="Path 765"
        ></path>
        <path
          fill="none"
          stroke={textHigh}
          strokeLinecap="round"
          strokeWidth="2"
          d="M321.481 694.5l4.413 4.412-4.413 4.413"
          data-name="Path 766"
        ></path>
        <path
          fill="none"
          stroke={textHigh}
          strokeLinecap="round"
          strokeWidth="2"
          d="M321.481 748.5l4.413 4.412-4.413 4.413"
          data-name="Path 768"
        ></path>
        <path
          fill="none"
          d="M0 0h20v20H0z"
          data-name="Path 753"
          transform="translate(27 688)"
        ></path>
        <g transform="translate(29 743)">
          <path fill="none" d="M0 0h20v20H0z" data-name="Path 773"></path>
          <path
            fill={textHigh}
            d="M9.667 7.833H8V2H6.333v5.833H4.667V2H3v5.833a3.322 3.322 0 003.125 3.308v7.525h2.083v-7.524a3.322 3.322 0 003.125-3.308V2H9.667zm4.167-2.5V12h2.083v6.667H18V2c-2.3 0-4.167 1.867-4.167 3.333z"
            data-name="Path 774"
            transform="translate(-.5 -.333)"
          ></path>
        </g>
        <g transform="translate(29 689)">
          <path fill="none" d="M0 0H20V20H0z" data-name="Rectangle 2559"></path>
          <path
            fill={textHigh}
            d="M9.5 6.488H2v1.667h7.5zm0 6.667H2v1.667h7.5zm4.45-3.333L11 6.872 12.175 5.7l1.767 1.767 3.533-3.537 1.192 1.175zm0 6.667L11 13.538l1.175-1.175 1.767 1.767 3.533-3.53 1.192 1.175z"
            data-name="Path 775"
            transform="translate(-.333 -.655)"
          ></path>
        </g>
        <g transform="translate(29 635)">
          <path fill="none" d="M0 0h20v20H0z" data-name="Path 776"></path>
          <path
            fill={textHigh}
            d="M17.475 12.717l1.192-1.192-1.192-1.192-2.975 2.975-7.142-7.141 2.975-2.975L9.142 2 7.95 3.192 6.758 2 4.975 3.783 3.783 2.592 2.592 3.783l1.191 1.192L2 6.758 3.192 7.95 2 9.142l1.192 1.192 2.975-2.976 7.141 7.142-2.975 2.975 1.192 1.192 1.192-1.192 1.192 1.192 1.783-1.783 1.192 1.192 1.192-1.192-1.192-1.192 1.783-1.783z"
            data-name="Path 777"
            transform="translate(-.333 -.333)"
          ></path>
        </g>
        <text
          fill={textHigh}
          data-name="Feb 26, 2024"
          fontFamily="OpenSans-Semibold, Open Sans"
          fontSize="12"
          fontWeight="600"
          transform="translate(180 135)"
        >
          <tspan x="-35.657" y="0">
            Feb 26, 2024
          </tspan>
        </text>
        <path
          fill={textHigh}
          d="M11.29 12l3.54-3.54a1 1 0 10-1.42-1.41l-4.24 4.24a1 1 0 000 1.42L13.41 17a1 1 0 101.42-1.41z"
          transform="translate(69.126 118.246)"
        ></path>
        <g fill={textHigh} data-name="Group 3278" transform="translate(-1)">
          <path
            d="M14.83 11.29l-4.24-4.24a1 1 0 00-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 001.42 1.41l4.24-4.24a1 1 0 000-1.42z"
            transform="translate(311.998 118.246)"
          ></path>
          <path
            d="M14.83 11.29l-4.24-4.24a1 1 0 00-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 001.42 1.41l4.24-4.24a1 1 0 000-1.42z"
            data-name="angle-right"
            transform="translate(317.998 118.246)"
          ></path>
        </g>
        <g
          fill={textHigh}
          data-name="Group 3279"
          transform="translate(28.877 125)"
        >
          <path
            d="M9.175 11.29l4.24-4.24a1 1 0 011.42 1.41L11.3 12l3.54 3.54a1 1 0 01-1.42 1.41l-4.24-4.24a1 1 0 010-1.42z"
            data-name="angle-right"
            transform="translate(-2.879 -6.754)"
          ></path>
          <path
            d="M9.175 11.29l4.24-4.24a1 1 0 011.42 1.41L11.3 12l3.54 3.54a1 1 0 01-1.42 1.41l-4.24-4.24a1 1 0 010-1.42z"
            data-name="angle-right"
            transform="translate(-8.879 -6.754)"
          ></path>
        </g>
        <path
          fill={textHigh}
          d="M14.83 11.29l-4.24-4.24a1 1 0 00-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 001.42 1.41l4.24-4.24a1 1 0 000-1.42z"
          data-name="angle-right"
          transform="translate(267.874 118.246)"
        ></path>
        <g data-name="Group 3268">
          <path
            fill={elevationOne}
            d="M360 0H0v96h360z"
            data-name="Tool bar bg"
          ></path>
          <text
            fill={textHigh}
            data-name="Daily Dashboard"
            fontFamily="OpenSans-Bold, Open Sans"
            fontSize="20"
            fontWeight="700"
            transform="translate(16 67)"
          >
            <tspan x="0" y="0">
              Daily Dashboard
            </tspan>
          </text>
          <path
            fill="none"
            stroke={elevationTwo}
            strokeWidth="1"
            d="M360 0L0 0"
            data-name="Line 19"
            transform="translate(0 96)"
          ></path>
        </g>
        <g data-name="Group 3288" transform="translate(-4160 -785)">
          <g filter="url(#Rectangle_903)" transform="translate(4160 785)">
            <path
              fill={bgColor}
              d="M0 0H360V80H0z"
              data-name="Rectangle 903"
              transform="translate(0 699)"
            ></path>
          </g>
          <g transform="translate(4472.034 1512.625)">
            <path
              fill={textLow}
              d="M18.428 14.844a7.2 7.2 0 10-8.9 0 11.992 11.992 0 00-7.459 9.809 1.206 1.206 0 002.4.264 9.593 9.593 0 0119.067 0 1.2 1.2 0 001.2 1.067h.132a1.2 1.2 0 001.055-1.319 11.992 11.992 0 00-7.495-9.821zm-4.449-.851a4.8 4.8 0 114.8-4.8 4.8 4.8 0 01-4.8 4.8z"
              transform="translate(-2.064 -1.995)"
            ></path>
          </g>
          <g transform="translate(4400.026 1512.625)">
            <path
              fill={textLow}
              d="M14 6.8A1.2 1.2 0 0012.8 8v12a1.2 1.2 0 002.4 0V8A1.2 1.2 0 0014 6.8zM8 14a1.2 1.2 0 00-1.2 1.2V20a1.2 1.2 0 002.4 0v-4.8A1.2 1.2 0 008 14zm12-2.4a1.2 1.2 0 00-1.2 1.2V20a1.2 1.2 0 002.4 0v-7.2a1.2 1.2 0 00-1.2-1.2zM22.4 2H5.6A3.6 3.6 0 002 5.6v16.8A3.6 3.6 0 005.6 26h16.8a3.6 3.6 0 003.6-3.6V5.6A3.6 3.6 0 0022.4 2zm1.2 20.4a1.2 1.2 0 01-1.2 1.2H5.6a1.2 1.2 0 01-1.2-1.2V5.6a1.2 1.2 0 011.2-1.2h16.8a1.2 1.2 0 011.2 1.2z"
              transform="translate(-2 -2)"
            ></path>
          </g>
          <g opacity="0.23" transform="translate(4253.092 1512.625)">
            <path
              fill={textHigh}
              d="M12.908 20.634a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm5.454 0a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm0-4.363a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm-5.454 0a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm7.636-13.09h-1.091v-1.09a1.091 1.091 0 00-2.182 0v1.091H8.545V2.091a1.091 1.091 0 00-2.182 0v1.091H5.272A3.272 3.272 0 002 6.454v15.271A3.272 3.272 0 005.272 25h15.272a3.272 3.272 0 003.272-3.272V6.454a3.272 3.272 0 00-3.272-3.272zm1.091 18.544a1.091 1.091 0 01-1.091 1.091H5.272a1.091 1.091 0 01-1.091-1.091v-9.817h17.453zm0-12H4.182V6.454a1.091 1.091 0 011.09-1.091h1.091v1.091a1.091 1.091 0 002.182 0V5.363h8.726v1.091a1.091 1.091 0 002.182 0V5.363h1.091a1.091 1.091 0 011.091 1.091zM7.454 16.271a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091zm0 4.363a1.091 1.091 0 10-1.091-1.091 1.091 1.091 0 001.091 1.091z"
              transform="translate(-2 -1)"
            ></path>
          </g>
          <ellipse
            cx="20"
            cy="20.5"
            fill={primaryColor}
            data-name="Ellipse 70"
            rx="20"
            ry="20.5"
            transform="translate(4320 1504)"
          ></ellipse>
          <rect
            width="2"
            height="16"
            fill={textColor}
            data-name="Rectangle 904"
            rx="1"
            transform="translate(4339 1517)"
          ></rect>
          <rect
            width="2"
            height="16"
            fill={textColor}
            data-name="Rectangle 905"
            rx="1"
            transform="rotate(90 1412 2936)"
          ></rect>
          <path
            fill={primaryColor}
            stroke="rgba(0,0,0,0)"
            strokeMiterlimit="10"
            strokeWidth="1"
            d="M4205.374 1519.849h0l-7.191-6.3a3.6 3.6 0 00-4.794 0l-7.189 6.3a3.6 3.6 0 00-1.2 2.7v10.478a3.6 3.6 0 003.6 3.6h14.377a3.6 3.6 0 003.6-3.6v-10.486a3.6 3.6 0 00-1.2-2.7zm-7.191 14.377h-4.794v-5.992a1.2 1.2 0 011.2-1.2h2.4a1.2 1.2 0 011.2 1.2zm5.992-1.2a1.2 1.2 0 01-1.2 1.2h-2.4v-5.992a3.6 3.6 0 00-3.6-3.6h-2.4a3.6 3.6 0 00-3.6 3.6v5.992h-2.375a1.2 1.2 0 01-1.2-1.2v-10.485a1.2 1.2 0 01.407-.9l7.193-6.292a1.2 1.2 0 011.582 0l7.191 6.292a1.2 1.2 0 01.407.9z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default DailyDashboardPreview;
